var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMtnPlain(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 134,
    height: 55,
    viewBox: "0 0 134 55",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.2083 37.2338C70.1739 37.2338 90.4105 28.897 90.4105 18.62C90.4105 8.33681 70.1739 0 45.2083 0C20.2427 0 0 8.33681 0 18.62C0 28.897 20.2427 37.2338 45.2083 37.2338Z",
    transform: "scale(1.47715)",
    fill: "#011B33"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4268 4.71701L16.6107 0H1.17762L0 4.71701H5.05142L2.57217 14.6283H7.89008L10.3693 4.71701H15.4268Z",
    transform: "translate(60.7005 13.7523) scale(1.47715)",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.7238 0H17.0259L12.1233 10.841V0H4.66709L0 18.6138H5.12567L8.16281 6.60129V18.6138H12.1233L17.9556 6.60129L15.1603 18.6138H20.0567L24.7238 0Z",
    transform: "translate(23.9597 13.7523) scale(1.47715)",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8213 0H14.9249L12.3651 9.90506L10.0284 0H4.66091L0 18.6138H4.90263L7.46244 8.48564L10.0284 18.6138H15.1604L19.8213 0Z",
    transform: "translate(80.3113 13.7523) scale(1.47715)",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0.669345 0L0 2.65916H5.32408L5.98732 0H0.669345Z",
    transform: "translate(63.0168 37.3197) scale(1.47715)",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMtnPlain);
export default __webpack_public_path__ + "static/media/MTN-Plain.061e45fe1b649a005d17a696310a2ad9.svg";
export { ForwardRef as ReactComponent };